/* eslint-disable no-undef */
module.exports = require('./legacy');
/* eslint-enable no-undef */
